// extracted by mini-css-extract-plugin
export var dropdown = "_rm-0";
export var imageWrapper = "_rm-3";
export var itemNameContainer = "_rm-1";
export var productImage = "_rm-2";
export var spinnerWrapper = "_rm-4";